import { store as createStore } from '@risingstack/react-easy-state'
import api from '../api'
import { AccountStatus } from '../constants/AccountStatus'

/**
 * [Store]
 */
const store = createStore({
  connected: null,
  update: null,
  initialized: false,
  payments: {
    loading: false
  },
  wallet: {
    loading: false,
    iban: { iban: null, bic: null }
  },
  mandate: {
    loading: false
  },
  rewards: {
    loading: false,
    availablePoints: null,
    content: []
  },
  isActive,
  refreshAccount,
  getAccount,
  getConnectedAccount,
  hasCouponCode,
  updateAccount,
  getPayments,
  getWallet,
  getRewards,
  updatePicture,
  getPaymentMandate,
  getInterventionDate
})

/**
 * [Cache management]
 */

/**
 * [Functions]
 */

function isActive () {
  return !store.connected || store.connected.status === AccountStatus.ACTIVE
}

function hasCouponCode () {
  return store.connected !== null
    && store.connected.appliedCouponCode !== null
    && store.connected.appliedCouponCode !== undefined
}

/**
 * Helper to set account
 * We use JSON.parse to create a copy of the object,
 * if we didn't do this, both object would have the same reference
 * @param {object} account
 */
function refreshAccount ({ account } = { account: store.connected }) {
  store.connected = JSON.parse(JSON.stringify(account))
  store.update = JSON.parse(JSON.stringify(account))
}

async function getConnectedAccount () {
  const account = await api.account.getAccount()
  refreshAccount({ account })
}

async function updateAccount ({ password, newPassword } = {}) {
  const account = await api.account.updateAccount({ account: store.update, password, newPassword })
  refreshAccount({ account })
}

async function getPayments ({ page } = { page: 0 }) {
  store.payments.loading = true
  const payments = await api.account.getPayments({ page })
  store.payments = { ...store.payments, ...payments }
  store.payments.loading = false
}

async function getWallet () {
  store.wallet.loading = true
  const wallet = await api.account.getWallet()
  store.wallet = { ...store.wallet, ...wallet }
  store.wallet.loading = false
}

async function getRewards () {
  store.rewards.loading = true
  const rewards = await api.account.getRewards()
  store.rewards.availablePoints = rewards.availablePoints
  store.rewards.content = rewards.usages
  store.rewards.loading = false
}

async function updatePicture ({ picture }) {
  const account = await api.account.updatePicture({ picture })
  store.connected = account
  refreshAccount({ account })
}

async function getPaymentMandate () {
  store.mandate.loading = true
  const mandate = await api.account.getPaymentMandate()
  store.mandate = {
    ...mandate,
    loading: false
  }
}

async function getInterventionDate () {
  store.interventionDate = await api.account.getInterventionDate()
}

async function getAccount () {
  await Promise.all([
    getConnectedAccount(),
    getInterventionDate()
  ])
}

export default store



// WEBPACK FOOTER //
// ./src/stores/account.js